import type { KoraLegalDocument, KoraLegalLinksLabels } from './types'

/** Where Kora Web serves each legal document (KORA-189). Public pages; no sign-in needed. */
export const KORA_LEGAL_PATHS: Readonly<Record<KoraLegalDocument, string>> = {
  terms: '/legal/terms',
  privacy: '/legal/privacy',
  imprint: '/legal/imprint'
}

/** Order the links are shown in; the same in every product. */
export const KORA_LEGAL_DOCUMENTS: readonly KoraLegalDocument[] = ['terms', 'privacy', 'imprint']

/**
 * `koraWebOrigin` null = same origin (Kora Web itself): the bare path. A product passes Kora Web's
 * origin and its language, so the page opens in the language the member was reading.
 */
export function buildKoraLegalHref(
  document: KoraLegalDocument,
  koraWebOrigin: string | null,
  locale: string
): string {
  const path = KORA_LEGAL_PATHS[document]
  if (koraWebOrigin === null) return path
  const origin = koraWebOrigin.replace(/\/+$/, '')
  return `${origin}${path}?lang=${locale === 'de' ? 'de' : 'en'}`
}

export const KORA_LEGAL_LINKS_LABELS_EN: KoraLegalLinksLabels = {
  navLabel: 'Legal',
  terms: 'Terms of use',
  privacy: 'Privacy notice',
  imprint: 'Imprint'
}

export const KORA_LEGAL_LINKS_LABELS_DE: KoraLegalLinksLabels = {
  navLabel: 'Rechtliches',
  terms: 'Nutzungsbedingungen',
  privacy: 'Datenschutzerklärung',
  imprint: 'Impressum'
}

/** Kora owns the wording (ADR-010 D8); unknown locales get English. */
export function koraLegalLinksLabels(locale: string): KoraLegalLinksLabels {
  return locale === 'de' ? KORA_LEGAL_LINKS_LABELS_DE : KORA_LEGAL_LINKS_LABELS_EN
}
